import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './CertificationForm.jsx'

export default createSubmit(name)